import { ref } from "vue"

export type ConfirmationType = "info" | "success" | "warning" | "danger"

export interface ConfirmationOptions {
  title?: string
  message: string
  contentKey?: string
  confirmText?: string
  cancelText?: string
  type?: ConfirmationType
  showIcon?: boolean
  focusConfirm?: boolean
  zIndex?: 10 | 20 | 30 | 40 | 50 | 60
}

interface ConfirmationState extends ConfirmationOptions {
  isOpen: boolean
  resolve?: (value: boolean) => void
}

const defaultState: Omit<ConfirmationState, "resolve"> = {
  isOpen: false,
  message: "",
  contentKey: undefined,
  title: "",
  confirmText: "Confirmar",
  cancelText: "Cancelar",
  type: "info",
  showIcon: true,
  focusConfirm: false,
}

const state = ref<ConfirmationState>({ ...defaultState })

function resetState() {
  state.value = {
    ...defaultState,
    resolve: undefined,
  }
}

export function useConfirmation() {
  const confirm = (options: ConfirmationOptions): Promise<boolean> => {
    return new Promise((resolve) => {
      state.value = {
        ...defaultState,
        ...options,
        isOpen: true,
        resolve,
      }
    })
  }

  const handleConfirm = () => {
    state.value.resolve?.(true)
    resetState()
  }

  const handleCancel = () => {
    state.value.resolve?.(false)
    resetState()
  }

  const close = () => handleCancel()

  return { state, confirm, handleConfirm, handleCancel, close }
}
